import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'common-ui-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  @Input() size: string;
  @Input() position: string;
  public loaderSizeClass: string;
  public loaderPositon = 'relative';

  ngOnInit(): void {
    this.loaderSizeClass = 'dna-loader-loop-' + this.size;
    if (this.position) {
      this.loaderPositon = this.position;
    }
  }
}
